import React from "react";
import Login from "./components/Login/Login";
function UnAuthentication() {
  return <Login />;
}

export default UnAuthentication;
